(function () {
  'use strict';

  var POOL_CATEGORIES = ['tank-tops', 'oversized-t-shirts', 'oversized-hoodies'];

  // variant_id → { category, size, color }
  var variantPool = {};
  var poolReady = false;

  function normalise(v) {
    return v ? v.trim().toLowerCase().replace(/-/g, ' ') : null;
  }

  function poolKey(info) {
    return info.color ? (info.color + '|' + info.size) : ('all|' + info.size);
  }

  function loadPool() {
    var tasks = POOL_CATEGORIES.map(function (cat) {
      return fetch('/collections/' + cat + '/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (body) {
          (body.products || []).forEach(function (product) {
            var opts = product.options || [];
            var colorIdx = -1, sizeIdx = -1;
            opts.forEach(function (opt, i) {
              var n = opt.name.toLowerCase();
              if (n === 'color' || n === 'colour') colorIdx = i;
              if (n === 'size') sizeIdx = i;
            });
            if (sizeIdx < 0) return;

            (product.variants || []).forEach(function (v) {
              var vals = [v.option1, v.option2, v.option3];
              var size = vals[sizeIdx];
              if (!size) return;
              variantPool[v.id] = {
                category: cat,
                size: size.trim().toUpperCase(),
                color: colorIdx >= 0 ? normalise(vals[colorIdx]) : null
              };
            });
          });
        })
        .catch(function () {});
    });
    return Promise.all(tasks).then(function () { poolReady = true; });
  }

  var toastTimer = null;
  function showError(msg) {
    var old = document.getElementById('cgd-toast');
    if (old) { clearTimeout(toastTimer); old.remove(); }

    var style = document.getElementById('cgd-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'cgd-style';
      style.textContent =
        '@keyframes cgdIn{from{opacity:0;transform:translateX(-50%) translateY(10px)}' +
        'to{opacity:1;transform:translateX(-50%) translateY(0)}}';
      document.head.appendChild(style);
    }

    var el = document.createElement('div');
    el.id = 'cgd-toast';
    el.setAttribute('style',
      'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);' +
      'background:#581126;color:#fff;padding:14px 22px;border-radius:8px;' +
      'font-size:14px;font-weight:600;z-index:99999;text-align:center;' +
      'box-shadow:0 4px 20px rgba(88,17,38,.4);max-width:340px;width:90%;' +
      'animation:cgdIn .25s ease'
    );
    el.textContent = msg;
    document.body.appendChild(el);

    toastTimer = setTimeout(function () {
      el.style.transition = 'opacity .3s';
      el.style.opacity = '0';
      setTimeout(function () { if (el.parentNode) el.remove(); }, 300);
    }, 4500);
  }

  function check(variantId, addQty) {
    var info = variantPool[variantId];
    if (!info) return Promise.resolve(false);

    var inv = window.__qdInv || {};
    var rawStock = inv[variantId];
    if (rawStock === undefined || rawStock === null) return Promise.resolve(false);
    var stock = Math.max(0, rawStock);
    var key = poolKey(info);

    return fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = 0;
        (cart.items || []).forEach(function (item) {
          var iv = variantPool[item.variant_id];
          if (iv && iv.category === info.category && poolKey(iv) === key) {
            inCart += item.quantity;
          }
        });

        if (inCart + addQty > stock) {
          var categoryLabel = info.category.replace(/-/g, ' ');
          var sizeLabel = info.size;
          var poolTotal = stock > 0 ? stock : inCart;
          var msg;

          if (stock === 0 && inCart > 0) {
            msg = 'Sorry, sizes are shared across all ' + categoryLabel +
                  ' — only ' + poolTotal + ' × ' + sizeLabel +
                  ' available, and they\'re all in your cart already.';
          } else {
            msg = 'Sorry, sizes are shared across all ' + categoryLabel +
                  ' — only ' + poolTotal + ' × ' + sizeLabel + ' available' +
                  (inCart > 0 ? ' (' + inCart + ' already in your cart)' : '') + '.';
          }
          showError(msg);
          return true;
        }
        return false;
      }).catch(function () { return false; });
  }

  function parseAdd(init) {
    if (!init || !init.body) return null;
    try {
      var body = init.body;

      // FormData / URLSearchParams
      if (typeof body.get === 'function') {
        var id = body.get('id');
        var qty = body.get('quantity');
        if (id) return { id: +id, qty: +(qty || 1) };
        return null;
      }

      // JSON string
      if (typeof body === 'string') {
        var obj = JSON.parse(body);
        if (obj.items && obj.items.length) {
          return { id: +obj.items[0].id, qty: +(obj.items[0].quantity || 1) };
        }
        if (obj.id) return { id: +obj.id, qty: +(obj.quantity || 1) };
      }
    } catch (e) {}
    return null;
  }

  // Gather the cart-items section IDs that the Fabric theme tracks for cart rendering
  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var sid = el.dataset.sectionId;
      if (sid && ids.indexOf(sid) === -1) ids.push(sid);
    });
    ids.push('cart-icon-bubble');
    return ids;
  }

  // When a cart add is blocked, we return a fake 200 success response that contains
  // the CURRENT cart sections HTML. This makes the product-form component re-render
  // the cart correctly (no items lost, no stale refresh) while our toast tells the user why.
  function buildBlockedResponse() {
    var sectionIds = getCartSectionIds();
    return fetch('/?sections=' + sectionIds.join(','), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        return new Response(
          JSON.stringify({ sections: sections }),
          { status: 200, headers: { 'Content-Type': 'application/json' } }
        );
      })
      .catch(function () {
        return new Response(
          JSON.stringify({ sections: {} }),
          { status: 200, headers: { 'Content-Type': 'application/json' } }
        );
      });
  }

  var _fetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && (input.url || '')) || '';

    if (poolReady && url.indexOf('/cart/add') !== -1) {
      var req = parseAdd(init);
      if (req && variantPool[req.id]) {
        return check(req.id, req.qty).then(function (blocked) {
          if (!blocked) return _fetch(input, init);
          return buildBlockedResponse();
        });
      }
    }

    return _fetch(input, init);
  };

  function refreshInventory() {
    fetch(window.location.pathname + '?_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var match = html.match(/window\.__qdInv\s*=\s*\{([\s\S]*?)"__end"\s*:\s*0\s*\}/);
        if (match) {
          try {
            window.__qdInv = JSON.parse('{' + match[1] + '"__end":0}');
          } catch (e) {}
        }
      })
      .catch(function () {});
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refreshInventory();
  });

  loadPool();
})();
